import React from 'react';
import { B1, H1, getTranslatedText } from '@nile/components';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

const EmptyDataWrap = styled.div`
  margin: 20px auto;
  border-radius: 8px;
  display: flex;
  padding: 10px;
  flex-direction: column;
`;
const EmptyContainerNewLayout = (props) => {
  const { intl, cardBg, fullWidth } = props;
  return (
    <div className={`mb25 ${fullWidth ? 'full-width' : ''}`}>
      <div className="fx jctr aend">
        <EmptyDataWrap cardBg={cardBg} className="actr">
          <div className="nodata-img">
            <img
              className="pt25"
              src={props.notFoundURL}
              alt="Kiwi standing on oval"
              width="150px"
            ></img>
          </div>
          <H1 className="text">
            <B1 className="nodata-text">
              {props.heading
                ? props.heading
                : getTranslatedText(intl, 'common.noDataFound')}
            </B1>
          </H1>
        </EmptyDataWrap>
      </div>

      {props.action && <div className="fx jctr p25">{props.action}</div>}
    </div>
  );
};

export default injectIntl(EmptyContainerNewLayout);
